import React from 'react';
import { Checkbox, Chip, FormControl, FormHelperText } from '@material-ui/core';
import { Input, InputLabel, ListItemText, MenuItem, Select } from '@material-ui/core';

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 54 * 5 + 8,
    },
  },
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  getContentAnchorEl: null,
};

const MultiSelect = props => {
  const { name, value = [], error, helperText, required, fullWidth } = props;

  return (
    <FormControl required={required} fullWidth={fullWidth} error={error}>
      <InputLabel htmlFor={name}>{props.label}</InputLabel>

      <Select
        multiple
        value={value}
        onChange={props.onChange}
        onBlur={props.onBlur}
        input={<Input id={name} name={name} required={required} />}
        renderValue={selected => (
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {selected.map(value => (
              <Chip key={value} label={value} size="small" />
            ))}
          </div>
        )}
        MenuProps={MenuProps}
      >
        {(props.options || []).map(({ id, text }) => (
          <MenuItem value={id} key={id}>
            <Checkbox checked={value.indexOf(id) > -1} value={id} color="primary" />
            <ListItemText primary={text} />
          </MenuItem>
        ))}
      </Select>
      <FormHelperText error>{error && helperText ? helperText : ' '}</FormHelperText>
    </FormControl>
  );
};

export default MultiSelect;
